//
//
//
//
//
//
//
//
//
//
//
//

import { Post } from "@/models";

export default {
  name: "postBottomBar",
  created() {},
  props: ["liked", "post", "user"],
  data() {
    return {};
  },
  methods: {
    reply: function() {
      if (!this.user) {
        this.$router.push({
          name: "logInSelection",
          query: { from: this.$route.path }
        });
        return;
      }

      this.$emit("reply");
    }
  },
  components: {}
};



// WEBPACK FOOTER //
// ./src/components/topic/JielongTopicBottomBar.vue